var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Wave, 水波图")]),
      _vm._v(" "),
      _c("h3", [_vm._v("属性 attr")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("说明")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{top,right,bottom,left,width,height}")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("percent")]),
            _vm._v(" "),
            _c("td", [_vm._v("百分比")]),
            _vm._v(" "),
            _c("td")
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("animation")]),
            _vm._v(" "),
            _c("td", [_vm._v("动画配置")]),
            _vm._v(" "),
            _c("td")
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("formatter")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本格式化")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("(fn: Function)")])])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("样式")]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("wave")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("水波图形的样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("shape")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("水波背景的样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("text")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本的样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }